// src/config/appConfig.ts

import ForestHealthDesktop from "../pages/mapPages/ForestHealth";

export interface Config {
  Pages: {
    [key: string]: boolean;
  };
  Options: {
    CommentSection: boolean;
  };
  defaultRoute: string;
}

const pagesConfig = {
  Catalogue: process.env.REACT_APP_ENABLE_CATALOGUE === 'true',
  Landing: process.env.REACT_APP_ENABLE_LANDING === 'true',
  SmartTraffic: process.env.REACT_APP_ENABLE_TRAFFIC === 'true',
  SmartBikeTraffic: process.env.REACT_APP_ENABLE_PEDESTRIAN_BIKE_TRAFFIC === 'true',
  SmartPedestrianTraffic: process.env.REACT_APP_ENABLE_PEDESTRIAN_BIKE_TRAFFIC === 'true',
  SmartTrafficFlow: process.env.REACT_APP_ENABLE_TRAFFIC_FLOW === 'true',
  SmartTrafficCondition: process.env.REACT_APP_ENABLE_TRAFFIC_CONDITION === 'true',
  SmartPedestrian: process.env.REACT_APP_ENABLE_PEDESTRIAN === 'true',
  SmartEmissions: process.env.REACT_APP_ENABLE_EMISSIONS === 'true',
  SmartEmissions_v2: process.env.REACT_APP_ENABLE_EMISSIONS_V2 === 'true',
  SmartNoise: process.env.REACT_APP_ENABLE_NOISE === 'true',
  SmartEnvironment: process.env.REACT_APP_ENABLE_ENVIRONMENT === 'true',
  SmartNaturalEvents: process.env.REACT_APP_ENABLE_NATURAL_EVENTS === 'true',
  SmartParking: process.env.REACT_APP_ENABLE_PARKING === 'true',
  SmartWaterLevel: process.env.REACT_APP_ENABLE_WATER_LEVEL === 'true',
  SmartWaterQuality: process.env.REACT_APP_ENABLE_WATER_QUALITY === 'true',
  FloodRisk: process.env.REACT_APP_ENABLE_FLOOD_RISK === 'true',
  FloodRiskManager: process.env.REACT_APP_ENABLE_FLOOD_RISK_MANAGER === 'true',
  SmartIllegalParking: process.env.REACT_APP_ENABLE_ILLEGAL_PARKING === 'true',
  SmartEnergyMonitoring: process.env.REACT_APP_ENABLE_ENERGY === 'true',
  SmartWasteDisposal: process.env.REACT_APP_ENABLE_WASTE === 'true',
  Parksuchverkehr: process.env.REACT_APP_ENABLE_PARKSUCHVERKEHR === 'true',
  Verkehrsaufkommen: process.env.REACT_APP_ENABLE_VERKEHRSAUFKOMMEN === 'true',
  Verlustzeiten: process.env.REACT_APP_ENABLE_VERLUSTZEITEN === 'true',
  QuelleZielBögen: process.env.REACT_APP_ENABLE_QUELLE_ZIEL_BOGEN === 'true',
  Parkverteilung: process.env.REACT_APP_ENABLE_PARKVERTEILUNG === 'true',
  Verkehrsspinne: process.env.REACT_APP_ENABLE_VERKEHRSSPINNE === 'true',
  LevelOfService: process.env.REACT_APP_ENABLE_LEVEL_OF_SERVICE === 'true',
  Parkdauer: process.env.REACT_APP_ENABLE_PARKING_DURATION === 'true',
  HeatIsland: process.env.REACT_APP_ENABLE_HEAT_ISLAND === 'true',
  SmartHeatIsland: process.env.REACT_APP_ENABLE_SMART_HEAT_ISLAND === 'true',
  SmartAverageSpeed: process.env.REACT_APP_ENABLE_AVERAGE_SPEED === 'true',
  SmartParkingSpots: process.env.REACT_APP_ENABLE_PARKING_SPOTS === 'true',
  SmartTicketing: process.env.REACT_APP_ENABLE_TICKETING === 'true',
  ParkingMeterData: process.env.REACT_APP_ENABLE_PARKING_METER_DATA === 'true',
  ParkingMeterStats: process.env.REACT_APP_ENABLE_PARKING_METER_STATS === 'true',
  ParkingMeterAnalysis: process.env.REACT_APP_ENABLE_PARKING_METER_ANALYSIS === 'true',
  ParkingViolations: process.env.REACT_APP_ENABLE_PARKING_VIOLATIONS === 'true',
  CurrentTrafficSituation: process.env.REACT_APP_ENABLE_CURRENT_TRAFFIC_SITUATION === 'true',
  TrafficData: process.env.REACT_APP_ENABLE_TRAFFIC_DATA === 'true',
  DownloadManager: process.env.REACT_APP_ENABLE_DOWNLOAD_MANAGER === 'true',
  SmartPrecipitation: process.env.REACT_APP_ENABLE_PRECIPITATION === 'true',
  WinterService: process.env.REACT_APP_ENABLE_WINTER_SERVICE === 'true',
  SmartMotorhomeTraffic: process.env.REACT_APP_ENABLE_MOTOR_HOME_TRAFFIC === 'true',

  Questionnaire: process.env.REACT_APP_ENABLE_QUESTIONNAIRE === 'true',
  QuestionnaireOverview: process.env.REACT_APP_ENABLE_QUESTIONNAIRE_OVERVIEW === 'true',
  ClimateActionTable: process.env.REACT_APP_ENABLE_CLIMATE_ACTION_TABLE === 'true',
  ClimateActionHeatmap: process.env.REACT_APP_ENABLE_CLIMATE_ACTION_HEATMAP === 'true',
  DonutOverview: process.env.REACT_APP_ENABLE_DONUT_OVERVIEW === 'true',
  InterflowingTrafficFlows: process.env.REACT_APP_ENABLE_INTERACTIVE_TRAFFIC_FLOWS === 'true',

  Playground: true,
  Playground2: true,
  Playground3: true,
  Playground4: true,
  Playground5: true,
  Playground6: true,
  Playground7: true,
  Playground8: true,
  Playground9: true,
  Playground10: true,
  Playground11: true,



  SpendingPulse: process.env.REACT_APP_SPENDING_PULSE === 'true',
  GeoInsights: process.env.REACT_APP_GEO_INSIGHTS === 'true',

  RealTimeTraffic: process.env.REACT_APP_ENABLE_REAL_TIME_TRAFFIC === 'true',
  SmartRealTimeTraffic: process.env.REACT_APP_ENABLE_SMART_REAL_TIME_TRAFFIC === 'true',
  SmartRealTimeTraffic1: process.env.REACT_APP_ENABLE_SMART_REAL_TIME_TRAFFIC === 'true',

  ForestFireMonitoring: process.env.REACT_APP_ENABLE_FOREST_FIRE_MONITORING === 'true',
  ForestFireVulnerability: process.env.REACT_APP_ENABLE_FOREST_FIRE_VULNERABILITY === 'true',
  WeatherMonitoring: process.env.REACT_APP_ENABLE_WEATHER_MONITORING === 'true',
  WeatherMeteoblueMap: process.env.REACT_APP_ENABLE_WEATHER_METEOBLUE_MAP === 'true',
  ForestHealth: process.env.REACT_APP_ENABLE_FOREST_HEALTH === 'true',
  ForestHealthManager: process.env.REACT_APP_ENABLE_FOREST_HEALTH === 'true',
  TrafficAnalyzer: false,
  Parkverstoesse: process.env.REACT_APP_ENABLE_PARKVERSTOESSE === 'true',

  SmartSurfaceWater: process.env.REACT_APP_ENABLE_SURFACE_WATER === 'true',
  SmartPedestrianOccupancy: process.env.REACT_APP_ENABLE_PEDESTRIAN_OCCUPANCY === 'true',



  //to-do add to new ladning page
  SmartFeuerwehrzufahrten: process.env.REACT_APP_ENABLE_FEUERWEHRZUFAHRTEN === 'true',
};
if (process.env.REACT_APP_TRAFFIC_ANALYZER_URL) {
  pagesConfig['TrafficAnalyzer'] = true;
}

const appConfig: Config = {
  Pages: pagesConfig,
  Options: {
    CommentSection: process.env.REACT_APP_ENABLE_COMMENT_SECTION === 'true'
  },
  defaultRoute: process.env.REACT_APP_DEFAULT_ROUTE || 'Landing'
};

export default appConfig;
export const noiseForecast = process.env.REACT_APP_ENABLE_NOISE_FORECAST === "true" ? true : false;
export const soilMoistureForecast = process.env.REACT_APP_ENABLE_ENVIRONMENT_FORECAST === "true" ? true : false;
export const wasteDisposalForecast = process.env.REACT_APP_ENABLE_WASTE_DISPOSAL_FORECAST === "true" ? true : false;
export const avgSpeedForecast = process.env.REACT_APP_ENABLE_AVG_SPEED_FORECAST === "true" ? true : false;
export const trafficForecast = process.env.REACT_APP_ENABLE_TRAFFIC_FORECAST === "true" ? true : false;
export const trafficAnalyzerUrl = process.env.REACT_APP_TRAFFIC_ANALYZER_URL;
export const parkingForecast = process.env.REACT_APP_ENABLE_PARKING_FORECAST === "true" ? true : false;